import React from 'react';
import { Box, Typography } from '@mui/material';

interface MetricDisplayProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  color?: string;
}

export const MetricDisplay: React.FC<MetricDisplayProps> = ({
  label,
  value,
  icon,
  color,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {icon}
        <Typography variant="overline" color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: color || 'text.primary',
          lineHeight: 1.2,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
